import { Component, Input } from '@angular/core';
import { TreeComponent } from '../tree/tree.component';
import { ContentComponent } from '../content/content.component';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';

@Component({
    selector: 'nxe-explorer',
    templateUrl: './explorer.component.html',
    styleUrls: ['./explorer.component.scss'],
    standalone: true,
    imports: [TreeComponent, ContentComponent, TranslateModule, TablerIconsModule],
})
export class ExplorerComponent {

    @Input() showSwitcher: boolean = true;
    @Input() showSendFile: boolean = false;
    @Input() showEditFile: boolean = false;

    /** Elenco cartelle aperto (conta solo sotto i 900px, dove sta sopra il contenuto). */
    protected treeOpen = true;

    protected toggleTree(): void {
        this.treeOpen = !this.treeOpen;
    }

}
